import api from './api';

export const loginService = async (email, password) => {
  try {
    // Para desarrollo sin backend, devolver datos mock
    return {
      token: 'mock-jwt-token',
      user: {
        id: 1,
        name: 'Miller Miller',
        email: email || 'trainer@altchat.io',
        role: 'trainer'
      }
    };
    
    // Código para cuando se conecte al backend real:
    // const response = await api.post('/auth/login', { email, password });
    // return response.data;
  } catch (error) {
    console.error('Error en loginService:', error);
    throw error;
  }
};

export const logoutService = async () => {
  try {
    // Para desarrollo sin backend
    return true;
    
    // Código para cuando se conecte al backend real:
    // await api.post('/auth/logout');
    // return true;
  } catch (error) {
    console.error('Error en logoutService:', error);
    throw error;
  }
};

export const forgotPasswordService = async (email) => {
  try {
    // Para desarrollo sin backend
    return { message: 'Instrucciones de recuperación enviadas' };
    
    // Código para cuando se conecte al backend real:
    // const response = await api.post('/auth/forgot-password', { email });
    // return response.data;
  } catch (error) {
    console.error('Error en forgotPasswordService:', error);
    throw error;
  }
};

export const resetPasswordService = async (token, password) => {
  try {
    // Para desarrollo sin backend
    return { success: true };
    
    // Código para cuando se conecte al backend real:
    // const response = await api.post('/auth/reset-password', { token, password });
    // return response.data;
  } catch (error) {
    console.error('Error en resetPasswordService:', error);
    throw error;
  }
};